import { render, staticRenderFns } from "./VerticalTabs.vue?vue&type=template&id=cdf43c28"
import script from "./VerticalTabs.vue?vue&type=script&lang=js"
export * from "./VerticalTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports